import React, { useCallback, useState } from 'react'
import { Col, Form } from 'react-bootstrap'

interface EditableBooleanMeetingResultProps {
  result: boolean
  basePath: string
  path: string
  onResultTextContentChange: (basePath: string, path: string, resultTextContent: string | boolean) => void
}

export const EditableBooleanMeetingResult: React.FC<EditableBooleanMeetingResultProps> = ({ result, basePath, path, onResultTextContentChange }) => {
  const [isChecked, setIsChecked] = useState(result)

  const handleTextContentChange = useCallback(
    (textContent: boolean) => {
      onResultTextContentChange(basePath, path, textContent)
    },
    [onResultTextContentChange, basePath, path],
  )
  return (
    <Col className='p-2'>
      <Form.Check id='editable-boolean-result' type='checkbox' disabled={false} className='d-flex'>
        <Form.Check.Input
          type='checkbox'
          disabled={false}
          checked={isChecked}
          onChange={() => {
            setIsChecked(!isChecked)
            handleTextContentChange(!isChecked)
          }}
          className='me-2 zocks-border-color-primary'
        />
      </Form.Check>
    </Col>
  )
}
